import { Link } from 'gatsby'
import React, { memo } from 'react'

const Breadcrumbs = ({ data }) => (
  <div className="breadcrumbs">
    {data?.map((item) => (
      <Link
        key={item?.link_text?.text}
        to={item.link?.url}
        className={`breadcrumbs-item ${item.disabled_link ? 'disabled' : ''}`}
      >
        {item?.link_text?.text}
      </Link>
    ))}
  </div>
)

export default memo(Breadcrumbs)
